/**
 * Produktkort (snippets/product-card.liquid): Köp direkt, utan laddning.
 *
 * Som Mix & Match (sections/Bundle.liquid): klicket syns med en gång (Tillagd i 1,3 s, antalet i varukorgen på bilden
 * och blå ring, antalsväljaren tillbaka till minsta antal) och varukorgen uppdateras i bakgrunden. En kö skickar ett
 * anrop i taget och slår ihop snabba klick, även på flera produkter. När Shopify svarat skickas samma händelser som
 * temats köpformulär skickar (variant:add och cart:change), så varukorgslådan, varukorgens antal och bekräftelsen
 * (snippets/cart-add-feedback.liquid) fungerar som förut. Går något fel (t.ex. slut i lager) visas Shopifys antal igen
 * och felmeddelandet under knappen.
 *
 * Med varukorgen som egen sida (Temainställningar → Varukorg) och på varukorgssidan skickas formuläret som vanligt.
 *
 * Antalet i varukorgen hålls i takt med varukorgen vid varje ändring (cart:change) och när sidan visas igen med
 * bakåtknappen. "+ Lägg till" i horizontal-product (varukorgslådans tips, produktsidan) går samma väg: formuläret har
 * data-pc-instant och produktens id. Mix & Match-korten (.pc--mix) sköts av sections/Bundle.liquid.
 *
 * Formulärets dolda egenskaper (properties[...], t.ex. leveransdatumet för en förhandsbeställd produkt) följer med
 * till varukorgsraden. Klick slås bara ihop när egenskaperna är desamma.
 */
(function () {
  if (window.__pcInit) return;
  window.__pcInit = true;

  var FLASH_MS = 1300;
  var ERROR_MS = 6000;

  function rootUrl() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function themeSetting(name) {
    var settings = window.themeVariables && window.themeVariables.settings;
    return settings ? settings[name] : undefined;
  }

  function cartErrorText() {
    var strings = window.themeVariables && window.themeVariables.strings;
    return (strings && strings.cartError) || 'Något gick fel. Försök igen.';
  }

  function cards() {
    return document.querySelectorAll('.pc[data-product-id]:not(.pc--mix)');
  }

  function cardsFor(productId) {
    return document.querySelectorAll('.pc[data-product-id="' + productId + '"]:not(.pc--mix)');
  }

  /* ── Antal i varukorgen: Shopifys antal + tillägg som inte bekräftats än ── */
  var serverCount = {}; // produkt-id → antal enligt senaste varukorgen
  var queuedCount = {}; // produkt-id → tillagt men inte bekräftat av Shopify

  function knownCount(productId) {
    if (!(productId in serverCount)) {
      // Antalet sidan renderades med
      var badge = document.querySelector('.pc[data-product-id="' + productId + '"] [data-pc-incart]');
      serverCount[productId] = badge ? parseInt(badge.getAttribute('data-count'), 10) || 0 : 0;
    }
    return serverCount[productId];
  }

  function restartAnimation(el, className) {
    el.classList.remove(className);
    void el.offsetWidth;
    el.classList.add(className);
  }

  function setInCart(card, quantity, pop) {
    var badge = card.querySelector('[data-pc-incart]');
    if (!badge) return;
    var text = badge.querySelector('[data-pc-incart-text]');
    if (text) text.textContent = (badge.getAttribute('data-template') || '').replace('__N__', quantity);
    badge.hidden = quantity <= 0;
    card.classList.toggle('is-incart', quantity > 0);
    if (pop && quantity > 0) restartAnimation(badge, 'pop');
  }

  function renderProduct(productId, pop) {
    var quantity = knownCount(productId) + (queuedCount[productId] || 0);
    Array.prototype.forEach.call(cardsFor(productId), function (card) { setInCart(card, quantity, pop); });
  }

  function updateFromCart(cart) {
    if (!cart || !cart.items) return;
    var byProduct = {};
    cart.items.forEach(function (item) {
      byProduct[item.product_id] = (byProduct[item.product_id] || 0) + item.quantity;
    });
    Array.prototype.forEach.call(cards(), function (card) {
      var productId = card.getAttribute('data-product-id');
      serverCount[productId] = byProduct[productId] || 0;
      setInCart(card, serverCount[productId] + (queuedCount[productId] || 0), false);
    });
  }

  document.addEventListener('cart:change', function (event) {
    if (event.detail && event.detail.cart) updateFromCart(event.detail.cart);
  });

  function fetchCart() {
    return fetch(rootUrl() + 'cart.js', { credentials: 'same-origin' }).then(function (response) { return response.json(); });
  }

  // Tillbaka med bakåtknappen: sidan kommer ur webbläsarens minne och kan visa ett gammalt antal
  window.addEventListener('pageshow', function (event) {
    if (!event.persisted || !cards().length) return;
    fetchCart().then(updateFromCart).catch(function () {});
  });

  /* ── Knappen och felraden ── */
  function flash(button) {
    if (!button) return;
    restartAnimation(button, 'is-added');
    clearTimeout(button._pcFlash);
    button._pcFlash = setTimeout(function () { button.classList.remove('is-added'); }, FLASH_MS);
  }

  function resetQuantity(form) {
    var input = form.querySelector('input[name="quantity"]');
    if (!input) return;
    var min = parseInt(input.getAttribute('min'), 10) || 1;
    // Temats quantity-input håller fältets bredd i takt med antalet siffror
    if ('quantity' in input) input.quantity = min;
    else input.value = String(min);
  }

  function rowOf(form) {
    return form.closest('.pc__buy') || form;
  }

  function clearError(form) {
    var error = rowOf(form).parentNode.querySelector('.pc__error');
    if (error) error.remove();
  }

  function showError(form, message) {
    var row = rowOf(form);
    var error = row.parentNode.querySelector('.pc__error');
    if (!error) {
      error = document.createElement('p');
      error.className = 'pc__error';
      error.setAttribute('role', 'alert');
      row.insertAdjacentElement('afterend', error);
    }
    error.textContent = message;
    clearTimeout(error._pcTimer);
    error._pcTimer = setTimeout(function () { error.remove(); }, ERROR_MS);
  }

  /* ── Kön: ett anrop i taget, snabba klick slås ihop ── */
  var waiting = []; // klick som inte skickats: { id, quantity, productId, form }
  var busy = false;

  function request(url, payload) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      credentials: 'same-origin',
      keepalive: true,
      body: JSON.stringify(payload)
    }).then(function (response) {
      return response.json().then(function (json) { return { ok: response.ok, json: json }; }, function () { return { ok: response.ok, json: {} }; });
    }).then(function (result) {
      if (!result.ok) {
        var error = new Error(result.json.description || result.json.message || 'Cart request failed');
        error.userMessage = result.json.description || '';
        throw error;
      }
      return result.json;
    });
  }

  function settle(batch) {
    batch.forEach(function (line) {
      queuedCount[line.productId] = (queuedCount[line.productId] || 0) - line.quantity;
      if (queuedCount[line.productId] <= 0) delete queuedCount[line.productId];
    });
  }

  function flush() {
    if (!waiting.length) {
      busy = false;
      return;
    }
    busy = true;

    var batch = waiting;
    waiting = [];
    var items = [], byVariant = {};
    batch.forEach(function (line) {
      var key = line.id + JSON.stringify(line.properties);
      if (byVariant[key]) {
        byVariant[key].quantity += line.quantity;
      } else {
        byVariant[key] = { id: line.id, quantity: line.quantity };
        if (line.properties) byVariant[key].properties = line.properties;
        items.push(byVariant[key]);
      }
    });

    // Samma sektioner som temats köpformulär ber om (varukorgslådan m.fl. lägger till sina)
    var sections = ['variant-added'];
    document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections: sections } }));
    var last = batch[batch.length - 1];

    request(rootUrl() + 'cart/add.js', { items: items, sections: sections.join(','), sections_url: rootUrl() + 'variants/' + last.id })
      .then(function (json) {
        return fetchCart().then(function (cart) {
          settle(batch);
          cart.sections = json.sections || {};
          updateFromCart(cart);
          last.form.dispatchEvent(new CustomEvent('variant:add', { bubbles: true, detail: { items: json.items || [json], cart: cart } }));
          document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'variant:add', cart: cart } }));
        });
      })
      .catch(function (error) {
        // Inget lades till: visa Shopifys antal igen och felet under knappen
        settle(batch);
        batch.forEach(function (line) {
          var button = line.form.querySelector('[data-pc-btn]');
          if (button) {
            clearTimeout(button._pcFlash);
            button.classList.remove('is-added');
          }
        });
        showError(batch[0].form, error.userMessage || cartErrorText());
        return fetchCart().then(updateFromCart).catch(function () {
          batch.forEach(function (line) { renderProduct(line.productId, false); });
        });
      })
      .then(flush);
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form.matches || !form.matches('.pc__form, [data-pc-instant]')) return;
    // Varukorgen som egen sida, eller kunden står på varukorgssidan: vanlig sidladdning, som temat gör
    if (themeSetting('cartType') === 'page' || themeSetting('pageType') === 'cart') return;

    // Produktkortet bär produktens id, horizontal-product har det på formuläret
    var card = form.closest('.pc') || form.closest('[data-product-id]');
    var idInput = form.querySelector('input[name="id"]');
    var productId = card && card.getAttribute('data-product-id');
    if (!productId || !idInput) return;
    event.preventDefault();

    var quantityInput = form.querySelector('input[name="quantity"]');
    var quantity = Math.max(1, parseInt(quantityInput && quantityInput.value, 10) || 1);

    var properties = null;
    Array.prototype.forEach.call(form.querySelectorAll('input[name^="properties["]'), function (input) {
      properties = properties || {};
      properties[input.name.slice(11, -1)] = input.value;
    });

    knownCount(productId);
    queuedCount[productId] = (queuedCount[productId] || 0) + quantity;
    waiting.push({ id: Number(idInput.value), quantity: quantity, properties: properties, productId: productId, form: form });

    clearError(form);
    renderProduct(productId, true);
    flash(form.querySelector('[data-pc-btn]'));
    resetQuantity(form);

    if (!busy) flush();
  });
})();
